import StatusCodes from 'http-status-codes';
import { parseCwidFromUrlParams } from 'core/prettyUrlsExpose';
import { fetchMandatoryFields, fetchMandatoryFieldsFailure } from './form';

export const fetchFormSettings = async ({
  store: { dispatch },
  match: { params },
}: any) => {
  try {
    const cwid = parseCwidFromUrlParams(params);
    if (!cwid) {
      return dispatch(fetchMandatoryFieldsFailure(StatusCodes.NOT_FOUND));
    }
    return fetchMandatoryFields(cwid)(dispatch);
  } catch (e) {
    return dispatch(fetchMandatoryFieldsFailure(StatusCodes.BAD_REQUEST));
  }
};
